import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { HlmButton } from '@lite-workspace/shared/helm-ui/button';
import { HlmSeparator } from '@lite-workspace/shared/helm-ui/separator';
import { galleryContactCard } from './gallery-sticky-bar.component';

/**
 * The public gallery's footer (spec «Галерея клиента» 40–42): divider → photographer name →
 * «Визитка фотографа» → the platform signature. Blocks with nothing behind them are absent,
 * never empty. The site is NOT printed here — it is a button inside the card, and the strip
 * repeated it.
 */
@Component({
  selector: 'gallery-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HlmButton, HlmSeparator, NgIcon],
  providers: [provideIcons({ galleryContactCard })],
  // 48 px between the blocks, 64 px under the last one (spec item 40).
  host: { class: 'flex w-full flex-col items-center gap-12 px-6 pb-16' },
  template: `
    <hlm-separator class="max-w-[var(--w-footer-rule)]" />

    @if (name()) {
      <div class="flex flex-col items-center gap-6">
        <div class="flex flex-col items-center gap-2 text-center">
          @if (name(); as photographer) {
            <span class="text-ink text-xl leading-7 font-medium">{{ photographer }}</span>
          }
        </div>
        @if (contactCardAvailable()) {
          <button hlmBtn variant="secondary" size="sm" type="button" class="pointer-coarse:min-h-11" (click)="contactCard.emit()">
            <ng-icon name="galleryContactCard" size="16" />
            Визитка фотографа
          </button>
        }
      </div>
    }

    @if (platformSignature()) {
      <p class="text-c3 text-xs tracking-[var(--ls-caps-m)] uppercase">
        Галерея от
        <a
          href="https://lumir.photo"
          target="_blank"
          rel="noopener"
          class="hover:text-ink hover:underline
            pointer-coarse:inline-flex pointer-coarse:min-h-11 pointer-coarse:items-center pointer-coarse:py-3"
          >Люмир Фото</a
        >
      </p>
    }
  `,
})
export class GalleryFooterComponent {
  readonly name = input<string | null>(null);
  /** The card window is offered only when the photographer turned it on and filled it. */
  readonly contactCardAvailable = input(false);
  /** «Галерея от Люмир Фото» — off when the account hides the platform signature. */
  readonly platformSignature = input(true);
  readonly contactCard = output<void>();
}
